<div class="secondarybar-wrap bb-fade-white-015 container-fluid rak-secondary-header-bar {{langClass}}">
    <div class="secbar">

        <!-- Contact (start side). Labels collapse to icon-only links as width runs out. -->
        <div class="secbar-group secbar-start">
            <a class="secbar-link secbar-phone" *ngIf="SettingsData?.website_phone != undefined; else phoneSkeleton"
               [href]="phoneHref" [attr.aria-label]="phoneText" [attr.title]="phoneText">
                <span class="secbar-ico" aria-hidden="true"><i class="fa fa-phone"></i></span>
                <span class="secbar-label header_rak_font" dir="ltr" [innerHTML]="SettingsData?.website_phone"></span>
            </a>
            <ng-template #phoneSkeleton>
                <ngx-skeleton-loader [theme]="{ width: '120px', height: '15px', 'background-color': '#808291', 'margin-bottom': '0' }"></ngx-skeleton-loader>
            </ng-template>

            <a class="secbar-link secbar-email" *ngIf="SettingsData?.website_email != undefined; else emailSkeleton"
               href="mailto:{{SettingsData?.website_email}}" [attr.aria-label]="SettingsData?.website_email" [attr.title]="SettingsData?.website_email">
                <span class="secbar-ico" aria-hidden="true"><i class="fa fa-envelope-o"></i></span>
                <span class="secbar-label header_rak_font" dir="ltr">{{SettingsData?.website_email}}</span>
            </a>
            <ng-template #emailSkeleton>
                <ngx-skeleton-loader [theme]="{ width: '120px', height: '15px', 'background-color': '#808291', 'margin-bottom': '0' }"></ngx-skeleton-loader>
            </ng-template>
        </div>

        <!-- Actions (end side) -->
        <div class="secbar-group secbar-end">
            <form role="search" [formGroup]="searchForm" novalidate="true" (ngSubmit)="submittingSearch()" class="secbar-search">
                <button type="submit" class="secbar-search-submit" [attr.aria-label]="searchPlaceholder || 'Search'">
                    <span class="secbar-ico" aria-hidden="true"><i class="fa fa-search"></i></span>
                </button>
                <input type="text" placeholder="{{searchPlaceholder}}" [attr.aria-label]="searchPlaceholder || 'Search'" name="search" formControlName="search">
            </form>

            <button type="button" class="secbar-ctl secbar-icon-btn secbar-search-toggle" (click)="searchOpen = !searchOpen"
                    [attr.aria-expanded]="searchOpen" [attr.aria-label]="searchPlaceholder || 'Search'" [attr.title]="searchPlaceholder || 'Search'">
                <span class="secbar-ico" aria-hidden="true"><i class="fa fa-search"></i></span>
            </button>

            <div class="secbar-socials">
                <raksme-social-icons [socialLoaded]="socialLoaded" [socialsData]="headerSocials.data"></raksme-social-icons>
            </div>

            <div class="secbar-lang">
                <span class="secbar-ico secbar-globe" aria-hidden="true"><i class="fa fa-globe"></i></span>
                <raksme-language-switcher></raksme-language-switcher>
            </div>

            <div class="secbar-account" [class.is-open]="accountOpen" *ngIf="toke_exist == true; else loginBtn">
                <button type="button" class="secbar-ctl secbar-btn" aria-haspopup="true" (click)="accountOpen = !accountOpen" [attr.aria-expanded]="accountOpen" [attr.aria-label]="header_account" [attr.title]="header_account">
                    <span class="secbar-ico" aria-hidden="true"><i class="fa fa-user-o"></i></span>
                    <span class="secbar-label" *ngIf="header_account != undefined">{{header_account}}</span>
                    <span class="secbar-label" *ngIf="header_account == undefined"><ngx-skeleton-loader [theme]="{ width: '60px', height: '15px', 'background-color': '#808291', 'margin-bottom': '0' }"></ngx-skeleton-loader></span>
                    <span class="secbar-caret" aria-hidden="true"><i class="fa fa-angle-down"></i></span>
                </button>
                <div class="ld-module-dropdown secbar-dropdown" id="dropdown-account">
                    <div class="ld-dropdown-menu-content">
                        <ul>
                            <li><a routerLink = "/my-account/{{arUrl}}/dashboard">{{generalLabels?.header_dashboard}}</a></li>
                            <li><a routerLink = "/my-account/{{arUrl}}/services">{{generalLabels?.header_account_service}}</a></li>
                            <li><a routerLink = "/my-account/{{arUrl}}/applications">{{generalLabels?.header_account_applications}}</a></li>
                            <li><a routerLink = "/my-account/{{arUrl}}/settings">{{generalLabels?.header_account_settings}}</a></li>
                            <li><a href="javascript:void(0)" (click)="openLogout(template)">{{generalLabels?.header_account_logout}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <ng-template #loginBtn>
                <a routerLink = "/sign-in{{arUrl}}" class="secbar-ctl secbar-btn" [attr.aria-label]="header_login || 'Sign in'" [attr.title]="header_login || 'Sign in'">
                    <span class="secbar-ico" aria-hidden="true"><i class="fa fa-user-o"></i></span>
                    <span class="secbar-label">{{header_login || 'Sign in'}}</span>
                </a>
            </ng-template>
        </div>

    </div>
</div>

<div class="search-inline" [class.search-visible]="searchOpen" style="height: 54px;">
    <form class="form ld-serach-mobile-form" [formGroup]="searchForm" novalidate="true" (ngSubmit)="submittingSearch()">
       <input type="text" class="form-control SearchBox"  placeholder="{{searchPlaceholder}}" [attr.aria-label]="searchPlaceholder || 'Search'" name="search" formControlName="search">
       <button type="submit" class="SearchSubmit" [attr.aria-label]="searchPlaceholder || 'Search'">
       <i class="fa fa-search"></i>
       </button>
       <a href="javascript:void(0)" class="search-close" aria-label="Close search" (click)="searchOpen = false">
       <i class="fa fa-times"></i>
       </a>
    </form>
 </div>

<ng-template #template>
    <div class="modal-body text-center">
      <p>{{generalLabels?.logout_popup_msg}} </p>
      <button type="button" class="logout_pop_btn btn btn-solid semi-round border-thin font-mobile-12px" (click)="confirm()" >
          <span class="btn-txt">{{generalLabels?.logout_popup_ok_btn}}</span>
      </button>
      <button type="button" class="logout_pop_btn btn btn-default semi-round btn-bordered border-thin border-fade-white-03 font-mobile-12px {{langClass}} btn-no" (click)="decline()" >
          <span class="btn-txt">{{generalLabels?.logout_popup_cancel_btn}}</span>
      </button>
    </div>
  </ng-template>